import Api from '../api';
import {
  LIST_RATE_LIMIT_POLICIES, LIST_RATE_LIMIT_POLICIES_URL,
  CREATE_RATE_LIMIT_POLICY, CREATE_RATE_LIMIT_POLICY_URL,
  UPDATE_RATE_LIMIT_POLICY, UPDATE_RATE_LIMIT_POLICY_URL,
  DELETE_RATE_LIMIT_POLICY, DELETE_RATE_LIMIT_POLICY_URL,
  LIST_TENANT_RATE_LIMITS, LIST_TENANT_RATE_LIMITS_URL,
  GET_TENANT_RATE_LIMIT, GET_TENANT_RATE_LIMIT_URL,
  SET_TENANT_TIER, SET_TENANT_TIER_URL,
  SET_TENANT_OVERRIDE, SET_TENANT_OVERRIDE_URL,
  REMOVE_TENANT_OVERRIDE, REMOVE_TENANT_OVERRIDE_URL,
} from '../lib/constant';
import { handleAPIDispatch } from '../lib/utils';

// ── Policy templates ─────────────────────────────────────────────────────

export function listRateLimitPolicies() {
  const request = Api.get(LIST_RATE_LIMIT_POLICIES_URL);
  return handleAPIDispatch(request, LIST_RATE_LIMIT_POLICIES);
}

// params: { name, capacity, fillRate, fillIntervalSecs, notes? }
export function createRateLimitPolicy(params) {
  const body = {
    name: params.name,
    capacity: params.capacity,
    fillRate: params.fillRate,
    fillIntervalSecs: params.fillIntervalSecs,
    notes: params.notes || undefined,
  };
  const request = Api.post(CREATE_RATE_LIMIT_POLICY_URL, body);
  return handleAPIDispatch(request, CREATE_RATE_LIMIT_POLICY);
}

export function updateRateLimitPolicy(name, params) {
  const url = UPDATE_RATE_LIMIT_POLICY_URL.replace('{name}', encodeURIComponent(name));
  const body = {
    name,
    capacity: params.capacity,
    fillRate: params.fillRate,
    fillIntervalSecs: params.fillIntervalSecs,
    notes: params.notes || undefined,
  };
  const request = Api.put(url, body);
  return handleAPIDispatch(request, UPDATE_RATE_LIMIT_POLICY);
}

export function deleteRateLimitPolicy(name) {
  const url = DELETE_RATE_LIMIT_POLICY_URL.replace('{name}', encodeURIComponent(name));
  const request = Api.delete(url);
  return handleAPIDispatch(request, DELETE_RATE_LIMIT_POLICY);
}

// ── Per-tenant tier ──────────────────────────────────────────────────────

export function listTenantRateLimits(search = '', page = 1, pageSize = 25) {
  const url = `${LIST_TENANT_RATE_LIMITS_URL}?search=${encodeURIComponent(search)}&page=${page}&pageSize=${pageSize}`;
  const request = Api.get(url);
  return handleAPIDispatch(request, LIST_TENANT_RATE_LIMITS);
}

export function getTenantRateLimit(tenantId) {
  const url = GET_TENANT_RATE_LIMIT_URL.replace('{tenantId}', encodeURIComponent(tenantId));
  const request = Api.get(url);
  return handleAPIDispatch(request, GET_TENANT_RATE_LIMIT);
}

// params: { tier }
export function setTenantTier(tenantId, params) {
  const url = SET_TENANT_TIER_URL.replace('{tenantId}', encodeURIComponent(tenantId));
  const body = { tenantId, tier: params.tier };
  const request = Api.put(url, body);
  return handleAPIDispatch(request, SET_TENANT_TIER);
}

// ── Per-tenant overrides ─────────────────────────────────────────────────

// params: { scope, capacity, fillRate, fillIntervalSecs, expiresAt?, reason? }
export function setTenantOverride(tenantId, params) {
  const url = SET_TENANT_OVERRIDE_URL.replace('{tenantId}', encodeURIComponent(tenantId));
  const body = {
    tenantId,
    scope: params.scope,
    capacity: params.capacity,
    fillRate: params.fillRate,
    fillIntervalSecs: params.fillIntervalSecs,
    expiresAt: params.expiresAt || undefined,
    reason: params.reason || undefined,
  };
  const request = Api.post(url, body);
  return handleAPIDispatch(request, SET_TENANT_OVERRIDE);
}

export function removeTenantOverride(tenantId, scope) {
  const url = REMOVE_TENANT_OVERRIDE_URL
    .replace('{tenantId}', encodeURIComponent(tenantId))
    .replace('{scope}', encodeURIComponent(scope));
  const request = Api.delete(url);
  return handleAPIDispatch(request, REMOVE_TENANT_OVERRIDE);
}
